module.exports = __webpack_public_path__ + "static/media/lock.7f1a1546.svg";